const Resources = {

    table_headers: [
        { 
          text:     'Department Name',  
          align:    'start', 
          value:    'name',
        //   type:     'link',
        },
        {   
            text:   'Cost Center Name',
            value:  'cost_center'
        },
        { 
          text:     'Personnel counter',
          value:    'personal_counter'
        },
        { 
            text:   `Associate's counter`,
            value:  'associate_counter'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Cost Center Departments',
            href:   '/building-departments',
            arrow:  " ",
        },
    ],

    excel_file_headers: {
        'Cost Center Name': 'cost_center_id',
        'Department Name': 'name',
        'Notes': 'notes'
    },

    excel_fields_required: {
        cost_center_id:     true,
        name:               true,
        notes:              false,
    },

    empty_format_data: [
        {
            cost_center_id:     '',
            name:               '',
            notes:              '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Department?', 
            instruction: `https://scribehow.com/embed/Add_a_Department__b5F9_T4VSnOToV9-B5Rzvw?as=scrollable`
        },
        {
            label: '¿How to delete Departments?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Departments__4x7mWfAaTHabmgx9bRhi2Q?as=scrollable`
        },
    ]

}

export default Resources